import { Type, ISetClock } from "../actions/Heartbeat.Actions";

export interface IHeartbeatState {
  clock: Date;
}

/** Default heartbeat state */
const defaultState: IHeartbeatState = {
  clock: new Date(),
};

/** Manages dispatched hearbeat updates
 * !! I've placed the application heartbeat into it's own top level reducer object
 * !! as it's updated every second and having it as a child of another can adversely affect component rendering if parent is on watchlist. --CC
 * @param state - Current state of app heartbeat
 * @param action - Action to apply to the heartbeat
 * @returns new state of ticker with actions applied
 */
export const HeartbeatReducer = (state: IHeartbeatState = defaultState, action: ISetClock): IHeartbeatState => {
  switch (action.type) {
    case Type.SET_CLOCK:
      return { ...state, clock: action.date };
    default:
      return state;
  }
};
